import { render, staticRenderFns } from "./SavedSearchDropDown.vue?vue&type=template&id=0a3bca96&scoped=true"
import script from "./SavedSearchDropDown.vue?vue&type=script&lang=js"
export * from "./SavedSearchDropDown.vue?vue&type=script&lang=js"
import style0 from "./SavedSearchDropDown.vue?vue&type=style&index=0&id=0a3bca96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3bca96",
  null
  
)

export default component.exports